import { GridColumnType } from "../../../../../components/FinalMolGrid/libs/data/gridColumnType";
import { EditGridColumnType } from "../../../../../components/FinalMolGrid/libs/data/editGridColumnType";

export const AdditionalAddOnsData = {
    columns: [
        {
            name: "Title",
            fieldName: "eventAddOnType",
            allowShort: false,
            allowEditColumn: true,
            editColumn: {
                editColType: EditGridColumnType.INPUT,
                placeholder: "Title",
                editColFieldName: "title",
                isDisable: false,
                editColValidation: [
                    { type: "required", message: "Title is required." },
                ],
            },
            colStyle: {
                width: "40%",
                textAlign: "center",
            }
        },
        {
            name: "Additional Fee",
            fieldName: "eventAddOnPrice",
            colType: GridColumnType.NUMERIC,
            allowEditColumn: true,
            editColumn: {
                editColType: EditGridColumnType.NUMERIC,
                placeholder: "Additional Fee",
                editColFieldName: "additionalFee",
                isDisable: false,
                editColValidation: [
                    { type: "required", message: "Adminsration Fee is required." },
                ],
            },
            colStyle: {
                textAlign: "right",
            },
            allowShort: false
        },
        {
            name: "Action",
            colType: GridColumnType.ACTION,
            defaultAction: {
                allowEdit: true,
                allowDelete: true,
            },
            allowShort: false
        },
    ],
    editSettings: {
        buttons: {
            save: true,
            cancel: true,
            delete: false,
        }
    },
    allowEdit: true,
    handleRowDataUpdate: null,
    OnColumnChangeEdit: null,
    hasChildGridTable: false,
};
